/**
 * Key to store whether the admin is logged in in localStorage.
 */
export const STORAGE_LOGGED_IN_KEY = 'is-logged-in'
